<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.sideTitel }}</dff-side-titel>
    <dff-side-tekst [titel]="vm.sideUndertitel" [tekst]="vm.sideTekst"></dff-side-tekst>
    <panel aria-labelledby="page-header">
      <div class="table-wrap">
        <div class="table">
          @for (linje of vm.prognose.linjer; track linje) {
            <div class="row">
              <span class="col col-1 {{ linje.cssClasses }}">{{ linje.col1 }}</span>
              <span class="col col-2 {{ linje.cssClasses }}">{{ linje.col2 }}</span>
              <span class="col col-3 {{ linje.cssClasses }}">{{ linje.col3 }}</span>
              <span class="col col-4 {{ linje.cssClasses }}">{{ linje.col4 }}</span>
            </div>
          }
        </div>
      </div>
    </panel>
  }
</dff-side>
